<template>
  <div class="acPhoneInputNew">
    <div class="acPhoneInputNew_label" v-if="label || note">
      {{ label }}
      <small class="acPhoneInputNew_note" v-if="note"> {{ note }} </small>
    </div>

    <vue-tel-input
      :id="id"
      :model-value="value"
      mode="auto"
      :auto-format="true"
      :preferred-countries="preferredCountries"
      :default-country="defaultCountry"
      :dropdown-options="dropdownOptions"
      :input-options="inputOptions"
      style-classes="acPhoneInputNew_wrapper"
      @on-input="onInput"
      @validate="onValidate"
      @country-changed="onCountryChanged"
      :valid-characters-only="true"
    />
    <div v-if="error" class="acPhoneInputNew_error" v-html="error"/>
    <div v-else-if="hit" class="acPhoneInputNew_hit" v-html="hit"/>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

import { VueTelInput } from 'vue-tel-input'
import 'vue-tel-input/vue-tel-input.css'

import i18n from '@web/plugins/i18n'

export default defineComponent({
  name: 'AcPhoneInput',
  components: {
    VueTelInput
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    error: {
      type: String,
      default: null
    },
    value: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: i18n.global.t('phone')
    },
    placeholder: {
      type: String,
      default: i18n.global.t('input.phone')
    },
    required: {
      type: Boolean,
      default: false
    },
    preferredCountries: {
      type: Array,
      default: () => ['RU', 'UA', 'KZ', 'BY', 'LT', 'LV', 'PL', 'CZ', 'EE', 'GE', 'AZ']
    },
    defaultCountry: {
      type: String,
      default: 'RU'
    },
    note: {
      type: String,
      default: ''
    },
    hit: {
      type: String,
      default: ''
    }
  },
  emits: ['on-input', 'on-validate', 'on-country-changed'],
  setup (props, ctx) {
    function onInput (payload) {
      ctx.emit('on-input', payload)
    }
    function onValidate (payload) {
      ctx.emit('on-validate', payload)
    }
    function onCountryChanged (payload) {
      ctx.emit('on-country-changed', payload)
    }
    const dropdownOptions = {
      showSearchBox: true,
      // searchBoxPlaceholder: '',
      showFlags: true,
      showCountryFlag: true,
      showDialCodeInSelection: false,
      showDialCodeInList: true
    }

    const inputOptions = computed(() => {
      return {
        autofocus: true,
        showDialCode: true,
        placeholder: props.placeholder,
        required: props.required,
        styleClasses: 'acPhoneInputNew_input'
      }
    })

    const isError = computed(() => Boolean(props.error))

    return {
      dropdownOptions,
      inputOptions,
      isError,
      onInput,
      onValidate,
      onCountryChanged
    }
  }
})
</script>

<style lang="scss">
.acPhoneInputNew {
  width: 100%;

  &_label {
    font-family: Inter;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--ac-color-dark-gray);

  }

  &_wrapper {
    border-top: 0;
    border-left: 0;
    border-right: 0;
    border-radius: 0;
    border-bottom: 1px solid var(--ac-color-light-gray);

    &:focus-within {
      box-shadow: none !important;
      border-color: var(--ac-color-light-gray) !important;
    }
  }

  &.--no-border &_wrapper {
    border-bottom: none !important;
  }

  &_input {
    padding-top: 8px;
    padding-bottom: 8px;
    font-family: Inter;
    font-weight: 400;
    font-size: 16px;
    line-height: 130%;
    color: var(--ac-color-black);
    @media (min-width: 768px) and (max-width: 1439px) {
      font-size: 14px;
      line-height: 17px;
    }
  }

  &_wrapper .vti__dropdown {
    padding-left: 0;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-right: 7px;
  }

  &_error {
    margin-top: 2px;
    font-family: Inter;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: var(--ac-color-red);
  }

  &_hit {
    margin-top: 2px;
    font-family: Inter;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--ac-color-dark-gray);
  }

  &_wrapper .vti__dropdown-list {
    width: 330px !important;
    border-radius: 0 0 22px 22px !important;

    @media (max-width: 768px) {
      width: 290px !important;
    }
  }

  &_wrapper .vti__search_box {
    width: 98% !important;
  }
}
</style>
